import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { FollowUpQuestionsWidgetComponent } from '../follow-up-questions-widget/follow-up-questions-widget.component';

export interface FollowUpQuestionsSheetData {
  followUp: Table.FollowUp;
  user: Table.User;
  userImageUrl?: string;
}

@Component({
  selector: 'app-follow-up-questions-sheet',
  templateUrl: './follow-up-questions-sheet.component.html',
  imports: [FollowUpQuestionsWidgetComponent],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FollowUpQuestionsSheetComponent {
  readonly data: FollowUpQuestionsSheetData = inject(MAT_BOTTOM_SHEET_DATA);
  private readonly bottomSheetRef = inject<MatBottomSheetRef<FollowUpQuestionsSheetComponent>>(MatBottomSheetRef);

  onCompleted(): void {
    this.bottomSheetRef.dismiss({ completed: true });
  }

  onFallback(): void {
    this.bottomSheetRef.dismiss({ fallbackToChat: true });
  }

  onClose(): void {
    this.bottomSheetRef.dismiss();
  }
}
